import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { PageSkeleton } from '@/components/ui/page-skeleton';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return <PageSkeleton />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/?login=true" replace />;
  }

  // Check if user has required role (roles is an array)
  if (requiredRole) {
    // If role is required but user has no roles array, deny access
    if (!user?.roles || !Array.isArray(user.roles)) {
      return <Navigate to="/" replace />;
    }

    const hasRequiredRole = user.roles.some(
      (role) => role === requiredRole || role === 'ADMIN'
    );
    if (!hasRequiredRole) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
